import { render, staticRenderFns } from "./Bundle.vue?vue&type=template&id=c79a567a&lang=pug"
import script from "./Bundle.vue?vue&type=script&lang=js"
export * from "./Bundle.vue?vue&type=script&lang=js"
import style0 from "./Bundle.vue?vue&type=style&index=0&id=c79a567a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports